import { AddressForm } from "@/components/address/AddressForm";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import { Country } from "../../../../../common/enums";
import { ClientType } from "../../../enums";
import { resolveClientAddressLabel } from "../../../utils";

type Props = {
  hasCorrespondenceAddress?: boolean;
};

export const ClientAddressesFormPart = ({ hasCorrespondenceAddress }: Props) => {
  const { t } = useTranslation();

  const form = Form.useFormInstance<{ type?: ClientType; nationality?: Country }>();
  const clientType = Form.useWatch("type", form);
  const nationality = Form.useWatch("nationality", form);

  return (
    <>
      <AddressForm
        formItemsNamePath={["address"]}
        label={resolveClientAddressLabel(clientType ?? ClientType.NATURAL, nationality)}
        required
      />

      <AddressForm
        formItemsNamePath={["correspondenceAddress"]}
        label={t("client.attrs.correspondenceAddress")}
        hasInitialAddress={hasCorrespondenceAddress}
      />
    </>
  );
};
